import React from 'react';
import {ToastContainer, ToastStore} from 'react-toasts';

import MediaManagerStyles from './MediaManager.css';

import utilities from './Utilities';
let Utilities = new utilities();

export default class MediaManager extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            items: undefined
        }

    }

    deleteItem = (id) => {

        window.globalVars.server.api({
            method: "delete",
            url: "/api/media/delete/" + this.props.type + "/" + id,
            data: {},
            then: function(res) {

                ToastStore.error(res.data.data);

                setTimeout(function() {
                    window.location.reload();
                }, 2000)

            }.bind(this),
            catch: function(e) {

                ToastStore.error("Failed to delete item");

            }.bind(this)
        })

    }

    getMedia = () => {

        window.globalVars.server.api({
            method: "get",
            url: "/api/media/" + this.props.type + "/0",
            data: {},
            then: function(res) {

                if (Utilities.isENU(res.data.data)) {
                    ToastStore.error("Coudln't get meida");
                } else {
                    this.setState({
                        items: res.data.data
                    })
                }

            }.bind(this),
            catch: function(e) {

                ToastStore.error("Coudln't get user");

            }.bind(this)
        })

    }

    componentDidMount() {
        this.getMedia();
        document.title = window.globalVars.pageTitleBefore + "Media Manager" + window.globalVars.pageTitleAfter;
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
    }

    triggerUploadDialog = () => {

        var event = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
        });

        var node = document.getElementById('profile-picture-upload-input');
        node.dispatchEvent(event);

    }

    onChange(e) {

        Utilities
            .getBase64(e.target.files[0])
            .then(function(base64) {

                window.globalVars.server.api({
                    method: "post",
                    url: "/api/media/upload/" + this.props.type,
                    data: {
                        base64Content: base64
                    },
                    then: function(res) {
                        if (res.data.success === false) {
                            ToastStore.error(res.data.data);
                        } else {
                            ToastStore.success(res.data.data);
                            setTimeout(function() {
                                window.location.reload();
                            }, 2000)
                        }
                    }.bind(this),
                    catch: function(e) {
                        //window.location.reload();
                    }.bind(this)
                })

            }.bind(this)).catch(function(err) {
                
            }.bind(this))

    }

    render() {

        return (
            <div className="media-manager-container">
                <div className="main-container">
                    <div className="media-manager">
                        <h1>{this.props.title}</h1>
                        <button className="upload-btn" onClick={ () => { this.triggerUploadDialog() } }>Upload</button>
                        { (this.state.items === undefined) &&
                            <p>Loading</p>
                        }
                        { ( (this.state.items !== undefined) && (this.state.items.length === 0) ) &&
                            <p>No Items</p>
                        }
                        { ( (this.state.items !== undefined) && (this.state.items.length !== 0) ) &&
                            <div className="items-container">
                                {this.state.items.map(item => {
                                    return(<div className="item">
                                        <img src={"https://s3-ap-southeast-1.amazonaws.com/frameitsg/" + this.props.type + "/" + item.name} />
                                        <div className="meta">
                                            <p>{item.name}</p>
                                            <button className="delete-btn" onClick={() => { if (window.confirm('Are you sure you want to delete this item')) this.deleteItem(item._id)} }>Delete</button>
                                        </div>
                                    </div>)
                                })}
                            </div>
                        }
                    </div>
                </div>
                <input id="profile-picture-upload-input" type="file" name="profile-picture" onChange={ (e) => {this.onChange(e)}} />
                <ToastContainer store={ToastStore}/>
            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/components/MediaManager.js